// Mukti Hospital ERP - Offline User Profile Cache (Phase 1.5)
// NEW FILE: src/services/offlineAuth.js
//
// Problem: AuthContext fetches the user profile from the API on every
// app load. When offline / server down, that call fails and user
// becomes null -> role guards (usePathologist etc.) redirect to /login
// and bills would be created as "Unknown User".
//
// Solution: after every successful profile fetch, keep a copy in
// localStorage. When the profile API is unreachable BUT a valid
// authToken still exists, restore the last known profile so the app
// knows exactly WHICH user is working offline.
//
// Note: this only restores identity for the UI/offline flow. Real
// permission checks still happen on the server during sync
// (x-api-key + role checks), so this adds no server-side risk.

const PROFILE_KEY = 'cachedUserProfile';

/** Save the user profile after a successful API fetch. Never throws. */
export const saveUserProfile = (profile) => {
  try {
    if (profile) {
      localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
    }
  } catch (err) {
    console.warn('[OfflineAuth] Failed to save profile:', err);
  }
};

/** Read the last known user profile. Returns object or null. */
export const readUserProfile = () => {
  try {
    const raw = localStorage.getItem(PROFILE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    console.warn('[OfflineAuth] Failed to read profile:', err);
    return null;
  }
};

/** Remove the cached profile (called on logout). Never throws. */
export const clearUserProfile = () => {
  try {
    localStorage.removeItem(PROFILE_KEY);
  } catch (err) {
    console.warn('[OfflineAuth] Failed to clear profile:', err);
  }
};
